import React, { Component, Fragment } from "react"

import { withAuth0 } from "@auth0/auth0-react"
import Alert from "react-bootstrap/Alert"
import Button from "react-bootstrap/Button"
import Form from "react-bootstrap/Form"
import { FormattedMessage } from "react-intl"

import Space from "./space"

class IdentityAddress extends React.Component {
  constructor(props) {
    super(props)
    this.handleCancel = this.handleCancel.bind(this)
    this.handleEdit = this.handleEdit.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleStartVerification = this.handleStartVerification.bind(this)
    this.handleUpdate = this.handleUpdate.bind(this)
    this.handleVerify = this.handleVerify.bind(this)
    this.state = {
      status: "view",
      addressStatus: this.props.identity.addressStatus,
      street: this.props.identity.street,
      city: this.props.identity.city,
      state: this.props.identity.state,
      zip: this.props.identity.zip,
      country: this.props.identity.country,
    }
  }

  handleCancel(e) {
    e.preventDefault()
    this.setState({
      status: "view",
      alert: null,
      street: this.state.street_original,
      city: this.state.city_original,
      state: this.state.state_original,
      zip: this.state.zip_original,
      country: this.state.country_original,
    })
  }

  handleEdit(e) {
    e.preventDefault()
    this.setState({
      status: "edit",
      alert: null,
      street_original: this.state.street,
      city_original: this.state.city,
      state_original: this.state.state,
      zip_original: this.state.zip,
      country_original: this.state.country,
    })
  }

  handleInputChange(e) {
    const target = e.target
    const name = target.name
    const value = target.type === "checkbox" ? target.checked : target.value

    this.setState({ [name]: value })
  }

  handleStartVerification(e) {
    e.preventDefault()
    this.setState(
      {
        status: "start_verification",
        alert: null,
      },
      () => {
        this.props.auth0
          .getAccessTokenSilently({
            audience: process.env.GATSBY_AUTH0_AUDIENCE,
            scope: process.env.GATSBY_AUTH0_SCOPE,
          })
          .then(accessToken => {
            const url = new URL(
              "/identity/startAddressVerification",
              process.env.GATSBY_API_URL
            )
            const params = {}
            Object.keys(params).forEach(key =>
              url.searchParams.append(key, params[key])
            )
            fetch(url, {
              method: "POST",
              headers: { Authorization: `Bearer ${accessToken}` },
            })
              .then(response => {
                if (response.ok) {
                  response.text().then(text => {
                    this.setState({
                      status: "view",
                      addressStatus: "Verifying (1)",
                    })
                  })
                } else {
                  response.text().then(text => {
                    this.setState({
                      status: "view",
                      alert: text,
                    })
                  })
                }
              })
              .catch(error => {
                this.setState({
                  status: "view",
                  alert: error.message,
                })
              })
          })
      }
    )
  }

  handleUpdate(e) {
    e.preventDefault()
    this.setState(
      {
        status: "update",
        alert: null,
      },
      () => {
        this.props.auth0
          .getAccessTokenSilently({
            audience: process.env.GATSBY_AUTH0_AUDIENCE,
            scope: process.env.GATSBY_AUTH0_SCOPE,
          })
          .then(accessToken => {
            const url = new URL(
              "/identity/updateAddress",
              process.env.GATSBY_API_URL
            )
            const params = {}
            params.street = this.state.street
            params.city = this.state.city
            params.state = this.state.state
            params.zip = this.state.zip
            params.country = this.state.country
            Object.keys(params).forEach(key =>
              url.searchParams.append(key, params[key])
            )
            fetch(url, {
              method: "POST",
              headers: { Authorization: `Bearer ${accessToken}` },
            }).then(response => {
              if (response.ok) {
                response.text().then(text => {
                  this.setState({
                    status: "view",
                  })
                })
              } else {
                response.text().then(text => {
                  this.setState({
                    status: "edit",
                    alert: text,
                  })
                })
              }
            })
          })
      }
    )
  }

  handleVerify(e) {
    e.preventDefault()
    this.setState(
      {
        status: "verify",
        alert: null,
      },
      () => {
        this.props.auth0
          .getAccessTokenSilently({
            audience: process.env.GATSBY_AUTH0_AUDIENCE,
            scope: process.env.GATSBY_AUTH0_SCOPE,
          })
          .then(accessToken => {
            const url = new URL(
              "/identity/verifyAddress",
              process.env.GATSBY_API_URL
            )
            const params = {}
            params.verificationCode = this.state.verificationCode
            Object.keys(params).forEach(key =>
              url.searchParams.append(key, params[key])
            )
            fetch(url, {
              method: "POST",
              headers: { Authorization: `Bearer ${accessToken}` },
            })
              .then(response => {
                if (response.ok) {
                  response.text().then(text => {
                    this.setState({
                      status: "view",
                      addressStatus: "Verified",
                    })
                  })
                } else {
                  response.text().then(text => {
                    this.setState({
                      status: "view",
                      alert: text,
                    })
                  })
                }
              })
              .catch(error => {
                this.setState({
                  status: "view",
                  alert: error.message,
                })
              })
          })
      }
    )
  }

  render() {
    return (
      <>
        {this.state.addressStatus == "New" && (
          <Alert variant="info">
            <FormattedMessage
              id={"Contact us to enable address verification."}
            />
          </Alert>
        )}
        {this.state.addressStatus == "Verifying (1)" && (
          <Alert variant="info">
            <FormattedMessage
              id={"We are verifying your address information. (1)"}
            />
          </Alert>
        )}
        {this.state.addressStatus == "Verifying (2)" && (
          <Alert variant="info">
            <FormattedMessage
              id={"We are verifying your address information. (2)"}
            />
          </Alert>
        )}
        {this.state.addressStatus == "Verified" && (
          <Alert variant="info">
            <FormattedMessage
              id={"Address information verified successfully."}
            />
          </Alert>
        )}
        {this.state.addressStatus == "Not Verified" && (
          <Alert variant="info">
            <FormattedMessage
              id={"Contact us to enable address verification."}
            />
          </Alert>
        )}
        {this.state.alert != null && (
          <Alert variant="danger">
            <FormattedMessage id={this.state.alert} />
          </Alert>
        )}
        <Form>
          <Form.Group>
            <Form.Label>
              <FormattedMessage id={"Street"} />
            </Form.Label>
            <Form.Control
              name="street"
              type="text"
              value={this.state.street}
              disabled={this.state.status != "edit"}
              onChange={this.handleInputChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>
              <FormattedMessage id={"City"} />
            </Form.Label>
            <Form.Control
              name="city"
              type="text"
              value={this.state.city}
              disabled={this.state.status != "edit"}
              onChange={this.handleInputChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>
              <FormattedMessage id={"State"} />
            </Form.Label>
            <Form.Control
              name="state"
              type="text"
              value={this.state.state}
              disabled={this.state.status != "edit"}
              onChange={this.handleInputChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>
              <FormattedMessage id={"Zip"} />
            </Form.Label>
            <Form.Control
              name="zip"
              type="text"
              value={this.state.zip}
              disabled={this.state.status != "edit"}
              onChange={this.handleInputChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>
              <FormattedMessage id={"Country"} />
            </Form.Label>
            <Form.Control
              name="country"
              type="text"
              value={this.state.country}
              disabled={this.state.status != "edit"}
              onChange={this.handleInputChange}
            />
          </Form.Group>
          {this.state.addressStatus == "Verifying (2)" && (
            <Form.Group>
              <Form.Label>
                <FormattedMessage id={"Verification Code"} />
              </Form.Label>
              <Form.Control
                name="verificationCode"
                type="text"
                value={this.state.verificationCode}
                disabled={this.state.status != "view"}
                onChange={this.handleInputChange}
              />
            </Form.Group>
          )}
          {this.state.status == "view" && this.state.addressStatus == "New" && (
            <>
              <Button variant="primary" onClick={this.handleEdit}>
                <FormattedMessage id={"Edit"} />
              </Button>
              <Space />
              <Button variant="warning" disabled>
                <FormattedMessage id={"Verify"} />
              </Button>
            </>
          )}
          {this.state.status == "view" && this.state.addressStatus == "Ready" && (
            <>
              <Button variant="primary" onClick={this.handleEdit}>
                <FormattedMessage id={"Edit"} />
              </Button>
              <Space />
              <Button variant="warning" onClick={this.handleStartVerification}>
                <FormattedMessage id={"Verify"} />
              </Button>
            </>
          )}
          {this.state.status == "start_verification" && (
            <>
              <Button variant="primary" disabled>
                <FormattedMessage id={"Edit"} />
              </Button>
              <Space />
              <Button variant="warning" disabled>
                <FormattedMessage id={"Verify"} />
              </Button>
            </>
          )}
          {this.state.status == "view" &&
            this.state.addressStatus == "Verifying (1)" && (
              <>
                <Button variant="primary" disabled>
                  <FormattedMessage id={"Edit"} />
                </Button>
                <Space />
                <Button variant="warning" disabled>
                  <FormattedMessage id={"Verify"} />
                </Button>
              </>
            )}
          {this.state.status == "view" &&
            this.state.addressStatus == "Verifying (2)" && (
              <>
                <Button variant="primary" disabled>
                  <FormattedMessage id={"Edit"} />
                </Button>
                <Space />
                <Button variant="warning" onClick={this.handleVerify}>
                  <FormattedMessage id={"Verify"} />
                </Button>
              </>
            )}
          {this.state.status == "verify" && (
            <>
              <Button variant="primary" disabled>
                <FormattedMessage id={"Edit"} />
              </Button>
              <Space />
              <Button variant="warning" disabled>
                <FormattedMessage id={"Verify"} />
              </Button>
            </>
          )}
          {this.state.status == "view" &&
            this.state.addressStatus == "Verified" && (
              <>
                <Button variant="primary" disabled>
                  <FormattedMessage id={"Edit"} />
                </Button>
                <Space />
                <Button variant="warning" disabled>
                  <FormattedMessage id={"Verify"} />
                </Button>
              </>
            )}
          {this.state.status == "view" &&
            this.state.addressStatus == "Not Verified" && (
              <>
                <Button variant="primary" disabled>
                  <FormattedMessage id={"Edit"} />
                </Button>
                <Space />
                <Button variant="warning" disabled>
                  <FormattedMessage id={"Verify"} />
                </Button>
              </>
            )}
          {this.state.status == "edit" && (
            <>
              <Button variant="primary" onClick={this.handleUpdate}>
                <FormattedMessage id={"Update"} />
              </Button>
              <Space />
              <Button variant="secondary" onClick={this.handleCancel}>
                <FormattedMessage id={"Cancel"} />
              </Button>
            </>
          )}
          {this.state.status == "update" && (
            <>
              <Button variant="primary" disabled>
                <FormattedMessage id={"Update"} />
              </Button>
              <Space />
              <Button variant="secondary" disabled>
                <FormattedMessage id={"Cancel"} />
              </Button>
            </>
          )}
        </Form>
      </>
    )
  }
}

export default withAuth0(IdentityAddress)
